import { OctagonX } from 'lucide-react';

const NoTransaction = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="rounded-full bg-gray-100 p-4">
        <OctagonX className="size-8 text-gray-400" />
      </div>
      <div className="text-lg font-medium text-gray-600">
        No transactions found
      </div>
    </div>
  );
};

export default NoTransaction;
